import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.4.0-canary.55_@babel+core@7.27.4_react-dom@19.0.0_react@19.0.0__react@19.0.0_sass@1.77.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/custom/cards/productCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SectionBody"] */ "/app/src/components/custom/newsPage/SectionBody.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/contexts/TranslationContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/lib/logging/client-logging.ts");
;
import(/* webpackMode: "eager", webpackExports: ["GroupField"] */ "/app/src/lib/payload/fields/GroupsField.tsx");
